import * as types from '../actions/actionTypes';
import initialState from './initialState';

export default function cursotipomonedaReducer(state= initialState.cursotipomoneda, action){
    let newState;
	switch(action.type){
         case types.LOAD_CURSOTIPOMONEDA_LIST_SUCCESS:		
            action.cursotipomoneda.filtroActivo=state.filtroActivo;
            action.cursotipomoneda.filtroActual=state.filtroActual;
            action.cursotipomoneda.showActivos=state.showActivos;
			 action.cursotipomoneda.paginaActual=action.cursotipomoneda.pageable.pageNumber;
			 action.cursotipomoneda.registrosPorPagina=action.cursotipomoneda.size;
            
            return action.cursotipomoneda;

        case types.BORRAR_CURSOTIPOMONEDA_SUCCESS:		            
            newState=Object.assign({}, state);
            newState.content=[...state.content.filter(cursotipomoneda => cursotipomoneda.id !== action.cursotipomoneda.id)];          
			return newState;    
            
        case types.ACTIVAR_CURSOTIPOMONEDA_SUCCESS:		            
            newState=Object.assign({}, state);
            newState.content=[...state.content.filter(cursotipomoneda => cursotipomoneda.id !== action.cursotipomoneda.id)];          
			 return newState;
            
        case types.SET_FILTRO_CURSOTIPOMONEDA:
			newState=Object.assign({}, state);
			newState.filtroActivo=action.filtro.filtroActivo;
			newState.filtroActual=action.filtro.filtroActual;
           newState.showActivos=action.filtro.showActivos;
            
            
			return newState;
		break;
            
		default:
			return state;
	}
}